"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.valueFor = exports.validateNumber = exports.validateNonEmpty = exports.renderMultipleAvatars = exports.pageTitle = exports.nativeShare = exports.isSmallScreen = exports.isSmallMobileScreen = exports.isScreenWidthLessThan = exports.isMobileScreen = exports.isMobile = exports.isLandscape = exports.getInitials = exports.getHomeTeamStyle = exports.getHomeTeamId = exports.getHlsURL = exports.getDiffDates = exports.getAwayTeamStyle = exports.getAnonAvatarImage = exports.getAcronymFromString = exports.gameResultAsString = exports.fullName2FirstLast = exports.formatUTCTimestampAsTimeAgo = exports.formatRank = exports.formatNamesOfAllPlayers = exports.dbQueryByLambda = exports.composeUtmCodes = exports.capitalizeFirstLetter = exports.capFirst = exports.ANON_AVATARS = void 0;

var _react = _interopRequireDefault(require("react"));

var _moment = _interopRequireDefault(require("moment"));

var _molecules = require("../molecules");

var _atoms = require("../atoms");

var _names = require("../formaters/names");

var _anon_avatar_blue = _interopRequireDefault(require("../assets/img/anon_avatar_blue.svg"));

var _anon_avatar_red = _interopRequireDefault(require("../assets/img/anon_avatar_red.svg"));

var _anon_avatar_yellow = _interopRequireDefault(require("../assets/img/anon_avatar_yellow.svg"));

var _limiter = require("./limiter");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Slobodan Djordjevic, Brian Bal
 */
// Images
// Const
var ANON_AVATARS = [_anon_avatar_red.default, _anon_avatar_yellow.default, _anon_avatar_blue.default]; // Helpers

exports.ANON_AVATARS = ANON_AVATARS;

var pageTitle = function pageTitle(titles) {
  var tmTitle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  window.tm_title = tmTitle;
  var sep = "\u203A";

  if (titles) {
    var title = "";

    if (Array.isArray(titles)) {
      title = titles.join(" ".concat(sep, " "));
    } else {
      title = titles;
    }

    title += " " + sep + " Trace iD";
    document.title = title;
  } else {
    return document.title;
  }
};

exports.pageTitle = pageTitle;

var valueFor = function valueFor(key, def, from) {
  var value = def;
  var dots = key.split(".");
  var scope = from;

  for (var i = 0; i < dots.length; i++) {
    var dot = dots[i];

    try {
      scope = scope[dot];
    } catch (err) {
      // console.error(err)
      // console.error("key", key, "from", from);
      return def;
    }
  } // eslint-disable-next-line eqeqeq


  if (scope != null) {
    value = scope;
  }

  return value;
};

exports.valueFor = valueFor;

var fullName2FirstLast = function fullName2FirstLast(fullName) {
  var firstName = fullName.trim();
  var lastName = "";
  var nameparts = firstName.split(" ");

  if (nameparts.length > 0) {
    lastName = capFirst(nameparts.pop());
    firstName = capFirst(nameparts.join(" "));
  }

  return {
    first_name: firstName,
    last_name: lastName
  };
};

exports.fullName2FirstLast = fullName2FirstLast;

var capFirst = function capFirst(name) {
  if (!name) return name;
  return name[0].toUpperCase() + name.substring(1);
};

exports.capFirst = capFirst;

var validateNumber = function validateNumber(val) {
  if (!val || !val.trim()) return null;
  var regex = /^[\d\.]+?$/; // eslint-disable-line no-useless-escape

  var res = regex.test(val);

  if (res) {
    return null;
  }

  return "Must be a number";
};

exports.validateNumber = validateNumber;

var validateNonEmpty = function validateNonEmpty(val) {
  if (val.length > 0) {
    return null;
  }

  return "Value is required";
};

exports.validateNonEmpty = validateNonEmpty;

var isScreenWidthLessThan = function isScreenWidthLessThan(width) {
  return window.matchMedia("only screen and (max-width: ".concat(width, "px)")).matches;
};

exports.isScreenWidthLessThan = isScreenWidthLessThan;

var isSmallMobileScreen = function isSmallMobileScreen() {
  return window.matchMedia("only screen and (max-width: 540px)").matches;
};

exports.isSmallMobileScreen = isSmallMobileScreen;

var isMobileScreen = function isMobileScreen() {
  return window.matchMedia("only screen and (max-width: 760px)").matches;
};

exports.isMobileScreen = isMobileScreen;

var isSmallScreen = function isSmallScreen() {
  return window.matchMedia("only screen and (max-width: 1010px)").matches;
};

exports.isSmallScreen = isSmallScreen;

var isLandscape = function isLandscape() {
  return isSmallScreen() && Math.abs(window.orientation ? window.orientation : 0) === 90;
};

exports.isLandscape = isLandscape;
var regex = /^#[0-9A-F]{6}$/i;

var getHomeTeamStyle = function getHomeTeamStyle(color) {
  var homeTeamCircleColor = regex.test(color) ? color : "#000000";
  var homeCircleBorder = homeTeamCircleColor.toUpperCase() === "#FFFFFF" ? "1px solid #BDBDBD" : "none";
  return {
    backgroundColor: homeTeamCircleColor,
    border: homeCircleBorder
  };
};

exports.getHomeTeamStyle = getHomeTeamStyle;

var getAwayTeamStyle = function getAwayTeamStyle(color) {
  var awayTeamCircleColor = "#FFFFFF";
  var awayCircleBorder = "";
  awayTeamCircleColor = regex.test(color) ? color : "#FFFFFF";
  awayCircleBorder = awayTeamCircleColor.toUpperCase() === "#FFFFFF" ? "1px solid #BDBDBD" : "none";
  return {
    backgroundColor: awayTeamCircleColor,
    border: awayCircleBorder
  };
};

exports.getAwayTeamStyle = getAwayTeamStyle;

var getDiffDates = function getDiffDates(date) {
  var today = (0, _moment.default)();

  var clipDate = _moment.default.utc(date);

  var diffMonths = (0, _moment.default)(today).diff(clipDate, "months");
  var diffDays = (0, _moment.default)(today).diff(clipDate, "days");

  if (diffMonths > 6) {
    return clipDate.format("MMM D, YYYY");
  } else if (diffMonths >= 1) {
    return diffMonths === 1 ? diffMonths + " MONTH AGO" : diffMonths + " MONTHS AGO";
  } else {
    return diffDays === 1 ? diffDays + " DAY AGO" : diffDays + " DAYS AGO";
  }
};

exports.getDiffDates = getDiffDates;

var composeUtmCodes = function composeUtmCodes(utmCampaign, utmSource, utmMedium) {
  var utmCodes = "";

  if (utmCampaign && utmSource && utmMedium) {
    utmCodes = "?utm_campaign=".concat(utmCampaign, "&utm_source=").concat(utmSource, "&utm_medium=").concat(utmMedium);
  }

  return utmCodes;
};

exports.composeUtmCodes = composeUtmCodes;

var dbQueryByLambda = function dbQueryByLambda(query, data) {
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "query";
  var useReadOnly = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var ro = useReadOnly ? "-ro" : "";
  return (0, _limiter.limiter)({
    name: "dbQueryByLambda",
    query: query,
    data: data,
    type: type,
    useReadOnly: useReadOnly
  }, function (success, failure) {
    return fetch("https://lapi.traceup.com/upload-".concat(process.env.REACT_APP_TRACE_ENV, "/data/db").concat(ro, "/query"), {
      method: "POST",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        query: [{
          type: type,
          table: query,
          data: data
        }]
      })
    }).then(function (resp) {
      return resp.json();
    }).then(function (data) {
      if (data && data.result && data.result[0].ok) {
        success();
        return data.result.length && data.result[0].data ? data.result[0].data.data : [];
      } else {
        failure();
        throw {
          error: "'Something went wrong'"
        };
      }
    });
  });
};

exports.dbQueryByLambda = dbQueryByLambda;

var getInitials = function getInitials(firstName, lastName) {
  var initials = firstName ? firstName.charAt(0).toUpperCase() : "";
  return lastName ? initials + lastName.charAt(0).toUpperCase() : initials;
};

exports.getInitials = getInitials;

var renderMultipleAvatars = function renderMultipleAvatars(card) {
  var avatarUrl = "https://lapi.traceup.com/tracebot-".concat(process.env.REACT_APP_TRACE_ENV, "/avatars?user=");
  var avatars = card.users.map(function (user, index) {
    var _card$home_team;

    return /*#__PURE__*/_react.default.createElement("a", {
      key: "".concat(index, "-").concat(user.user_id),
      href: "".concat(process.env.REACT_APP_GO_TRACEUP, "/#/").concat((_card$home_team = card.home_team) === null || _card$home_team === void 0 ? void 0 : _card$home_team.name, "/games/").concat(card.game_id, "/goals/0/players/").concat(card.users[index].trace_number),
      target: "_blank",
      rel: "noreferrer"
    }, /*#__PURE__*/_react.default.createElement(_molecules.Avatar, {
      key: user.user_id,
      size: 40,
      className: "moment-avatars",
      imageUrl: avatarUrl + user.user_id,
      initials: getInitials(user.first_name, user.last_name),
      marginRight: "2",
      marginTop: "1",
      marginBottom: "1"
    }));
  });
  return /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    className: "user-data-avatars"
  }, avatars);
};

exports.renderMultipleAvatars = renderMultipleAvatars;

var formatRank = function formatRank(rank) {
  // eslint-disable-next-line quotes
  return rank === 1 ? "\uD83E\uDD47 " + rank + ".\xA0" : rank + ".\xA0";
};

exports.formatRank = formatRank;

var formatNamesOfAllPlayers = function formatNamesOfAllPlayers(card) {
  var names = card.users.map(function (user, index) {
    var _card$home_team2;

    return /*#__PURE__*/_react.default.createElement("a", {
      key: "".concat(index).concat(user.user_id),
      href: "".concat(process.env.REACT_APP_GO_TRACEUP, "/#/").concat((_card$home_team2 = card.home_team) === null || _card$home_team2 === void 0 ? void 0 : _card$home_team2.name, "/games/").concat(card.game_id, "/goals/0/players/").concat(card.users[index].trace_number),
      target: "_blank",
      className: "preview-name-url",
      rel: "noreferrer"
    }, (0, _names.formatFullName)(user), card.users.length > 1 && index !== card.users.length - 1 ? "," : "", "\xA0");
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, card.rank && formatRank(card.rank), names);
};

exports.formatNamesOfAllPlayers = formatNamesOfAllPlayers;

var isMobile = function isMobile() {
  var isMobile = false;

  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    isMobile = true;
  }

  return isMobile;
};

exports.isMobile = isMobile;

var nativeShare = function nativeShare(url, text) {
  if (navigator.share && isMobile()) {
    navigator.share({
      text: text,
      url: url
    }).then(function () {
      console.log("Native Share Moment", "success");
    }).catch(function (err) {
      console.log("Native Share Moment", "failed", err);
    });
    return true;
  }

  return false;
};

exports.nativeShare = nativeShare;

var getHomeTeamId = function getHomeTeamId(moment) {
  var id = ""; // eslint-disable-next-line no-prototype-builtins

  var hasMetaProp = moment && moment.hasOwnProperty("meta");

  if (hasMetaProp) {
    var _moment$meta$home_tea;

    id = (_moment$meta$home_tea = moment.meta.home_team) === null || _moment$meta$home_tea === void 0 ? void 0 : _moment$meta$home_tea.id;
  } else {
    var _moment$home_team;

    id = (_moment$home_team = moment.home_team) === null || _moment$home_team === void 0 ? void 0 : _moment$home_team.id;
  }

  return id;
};

exports.getHomeTeamId = getHomeTeamId;

var getHlsURL = function getHlsURL(moment) {
  var hlsURL;
  var tm = getHomeTeamId(moment); // eslint-disable-next-line no-prototype-builtins

  var hasBasePath = moment && moment.hasOwnProperty("base_path");

  if (hasBasePath) {
    hlsURL = "".concat(moment.base_path).concat(moment.dynamic_hls);
  } else {
    hlsURL = "/teams/" + tm + "/games/" + tm + "-" + moment.game_id + "/" + moment.dynamic_hls;
  }

  return hlsURL;
};

exports.getHlsURL = getHlsURL;

var capitalizeFirstLetter = function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

exports.capitalizeFirstLetter = capitalizeFirstLetter;

var formatUTCTimestampAsTimeAgo = function formatUTCTimestampAsTimeAgo(timestamp) {
  return timestamp ? "".concat((0, _moment.default)(timestamp).fromNow()) : "";
};

exports.formatUTCTimestampAsTimeAgo = formatUTCTimestampAsTimeAgo;

var gameResultAsString = function gameResultAsString(homeTeam, awayTeam) {
  var resultOnly = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var result = "draw";

  if (!resultOnly) {
    result += " with";
  }

  if ((homeTeam === null || homeTeam === void 0 ? void 0 : homeTeam.score) > (awayTeam === null || awayTeam === void 0 ? void 0 : awayTeam.score)) {
    result = "win";

    if (!resultOnly) {
      result += " against";
    }
  } else if ((homeTeam === null || homeTeam === void 0 ? void 0 : homeTeam.score) < (awayTeam === null || awayTeam === void 0 ? void 0 : awayTeam.score)) {
    result = "loss";

    if (!resultOnly) {
      result += " against";
    }
  }

  return result;
};

exports.gameResultAsString = gameResultAsString;

var getAcronymFromString = function getAcronymFromString(name) {
  var initials = "•••";

  if ((name === null || name === void 0 ? void 0 : name.length) > 0) {
    var nameParts = name.split(" ");
    initials = nameParts[0].toUpperCase().charAt(0);

    if (nameParts.length > 1) {
      initials += nameParts[nameParts.length - 1].charAt(0).toUpperCase();
    }
  }

  return initials;
};

exports.getAcronymFromString = getAcronymFromString;

var getAnonAvatarImage = function getAnonAvatarImage() {
  var idx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var usableIdx = null; // If an index is provided, use it

  var anonUrlsCount = ANON_AVATARS.length;

  if (idx) {
    usableIdx = idx % anonUrlsCount;
  } else {
    usableIdx = Math.floor(Math.random() * anonUrlsCount);
  }

  var imageUrl = ANON_AVATARS[usableIdx];
  return imageUrl;
};

exports.getAnonAvatarImage = getAnonAvatarImage;